export default function ErrorPage() {
  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "clamp(16px, 6vw, 32px)" }}>
      <section style={{ textAlign: "center", maxWidth: 480 }}>
        <h1 className="mono" style={{ letterSpacing: "0.18em", textTransform: "uppercase" }}>Something broke</h1>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          The ritual misfired. Reload the page or contact support@salesdemon.ai if the problem persists.
        </p>
      </section>
    </main>
  )
}
